import { createTheme } from "@mui/material/styles";

type General = {
  backgroundColor?: string;
  fontColorPrimary?: string;
  fontColorSecondary?: string;
  fontFamily?: string;
};

export const configureDesignSystem = ({
  fontColorPrimary,
  fontColorSecondary,
  fontFamily,
}: General) =>
  createTheme({
    palette: {
      primary: {
        main: fontColorPrimary || "#0C20B5",
      },
      secondary: {
        main: fontColorSecondary || "#B0B0B0",
      },
      error: { main: "#B02F2F" },
    },

    typography: {
      fontFamily: Boolean(fontFamily) ? fontFamily : "Nunito",
      allVariants: {
        textTransform: "none",
        letterSpacing: ".2px",
        lineHeight: "20px",
        color: "#343E75",
      },
    },
    shape: { borderRadius: 8 },
    spacing: 8,
    components: {
      MuiTextField: { defaultProps: { size: "small" } },
      MuiAutocomplete: { defaultProps: { size: "small" } },
      MuiIconButton: { defaultProps: { size: "small" } },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
          size: "small",
          disableTouchRipple: true,
          sx: {
            "&.MuiButtonBase-root:hover": {
              bgcolor: "transparent",
            },
          },
        },
        styleOverrides: {
          colorInherit: {
            backgroundColor: "#F2F3F5",
            borderColor: "#E4E7EB",
            color: "#343E75",
            border: "1px solid #CFCFCF",
          },
        },
      },
    },
  });
